import React, { FunctionComponent } from "react";
import icon from "./reportsIcon.svg";

interface IReportsIcon {
    style?: React.CSSProperties;
    className?: string;
}

const ReportsSvg: FunctionComponent<IReportsIcon> = (props) => {
    return (
        <img
            src={icon}
            className={props.className}
            alt="down chevron"
            style={props.style}
        />
    );
};

export default ReportsSvg;
